import api from './api';
import { CPB_URL } from './servers';
import apiMap from './apiMaps';

export const getUbicaciones = (data) => api.post(`${CPB_URL}/geocercas/getUbicaciones`, data);
export const respuestaGogle = (data) =>
  apiMap.get(
    `https://maps.googleapis.com/maps/api/geocode/json?address=${data}&key=${process.env.REACT_APP_GOOGLE_API_KEY}`
  );
export const respuestaGogleLocation = (data) =>
  apiMap.get(
    `https://maps.googleapis.com/maps/api/geocode/json?latlng=${data}&key=${process.env.REACT_APP_GOOGLE_API_KEY}`
  );

// geocode.js

export const handleGeocode = async (parametro) => {
  const geocoder = new window.google.maps.Geocoder();
  console.log('parametro', parametro);
  const geocodePromise = new Promise((resolve, reject) => {
    geocoder.geocode({ address: parametro }, (results, status) => {
      if (status === 'OK') {
        resolve(results);
      } else {
        reject(new Error(`Geocode was not successful for the following reason: ${status}`));
      }
    });
  });
  try {
    const results = await geocodePromise;
    return results;
  } catch (error) {
    console.error(error);
    return null;
  }
};
